<template>
  <div>
    <v-app-bar color="#1F88E5" dense dark flat :height="64">
      <v-app-bar-nav-icon size="28" @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title>Onboarding</v-toolbar-title>
      <v-spacer></v-spacer>
      <base-timer v-show="false" @time-up="logout" />
      <v-toolbar-title id="user_name_title">{{
        $store.getters["user"].name
      }}</v-toolbar-title>
      <v-btn icon>
        <v-icon size="28">mdi-account-outline</v-icon>
      </v-btn>
      <v-menu left bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon size="28"> mdi-google-translate</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            :style="
              this.$localizationLanguage === 'tr'
                ? 'background-color:#001133'
                : ''
            "
            @click="() => this.$setLocalizationLanguage('tr')"
          >
            <v-list-item-title
              :style="this.$localizationLanguage === 'tr' ? 'color:white' : ''"
              >TR</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            :style="
              this.$localizationLanguage === 'en'
                ? 'background-color:#001133'
                : ''
            "
            @click="() => this.$setLocalizationLanguage('en')"
          >
            <v-list-item-title
              :style="this.$localizationLanguage === 'en' ? 'color:white' : ''"
              >EN</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu right bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon size="28">mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>{{ $t("logout") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <navigation-menu :drawer="drawer" :close-menu="() => (drawer = false)" />
  </div>
</template>
<script>
import AppBar from "./mixin/AppBar";

export default {
  mixins: [AppBar]
};
</script>
<style lang="scss" scoped>
.h-56 {
  height: 56px !important;
}
.v-app-bar {
  background-color: #2c3e50 !important;
}
#user_name_title {
  font-size: 0.95rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AppBar.vue